import { NameOfIndexForRecordingUuidThenRequestIdThenCategoryThenName, type DbRecordedEvent, type UUID } from "./DatabaseTypes";
import { requireEvidenceDatabase } from "./getDatabase";
import { action, observable } from "mobx";
import { GetsDbEventsByRequestId } from "./GetsDbEventsByRequestId";

export class DbEventsForRequestCache implements GetsDbEventsByRequestId {
	constructor (public readonly recordingUuid: UUID) {}

	requestsOrUndefinedByIndex = observable.map<string, DbRecordedEvent[] | undefined>();
	requestsPromiseByIndex = observable.map<string, Promise<DbRecordedEvent[] | undefined>>();

	protected addAction = action ( (requestId: string, event: DbRecordedEvent[] | undefined) => {
		this.requestsOrUndefinedByIndex.set(requestId, event);
	});

	protected fetchEvents = async (requestId: string) => {
		const db = await requireEvidenceDatabase();
		const events = await db.getAllFromIndex("events", NameOfIndexForRecordingUuidThenRequestIdThenCategoryThenName,
			IDBKeyRange.bound([this.recordingUuid, requestId, "\0", "\0"], [this.recordingUuid, requestId, "\xFFFF", "\xFFFF"]));
		const sortedEvents = events.sort((a, b) => a.eventIndex - b.eventIndex);
		this.addAction(requestId, sortedEvents);
		return events;
	}

	getAsync = async (requestId: string): Promise<DbRecordedEvent[] | undefined> => {
		const cachedEvents = this.requestsOrUndefinedByIndex.get(requestId);
		if (cachedEvents != null) {
			return cachedEvents;
		}
		const cachedEventPromise = this.requestsPromiseByIndex.get(requestId);
		if (cachedEventPromise != null) {
			return await cachedEventPromise;
		}
		const getEventsPromise = this.fetchEvents(requestId);
		this.requestsPromiseByIndex.set(requestId, getEventsPromise);
		return await getEventsPromise;
	}
	
	get = (requestId: string) => {
		if (!this.requestsPromiseByIndex.has(requestId)) {			
			this.getAsync(requestId);
		}
		return this.requestsOrUndefinedByIndex.get(requestId);
	}

}
